<template>
  <div
    class="video-wrapper"
    v-bind:style="videoDimensions"
  >
    <video
      mute
      loop
      playsinline
      autoplay="autoplay"
      class="video-bg"
      ref="video"
      poster="/static/img/poster.jpg"
    >
      <source src="/static/video/dignity-background.mp4" type="video/mp4">
      <source src="/static/video/dignity-background.webm" type="video/webm">
      Your browser does not support the video tag.
    </video>
  </div>
</template>

<script>
export default {
  name: 'VideoBackground',
  data: function () {
    return {
      width: 0,
      height: 0,
      stated: false
    }
  },
  mounted: function () {
    this.applyDimensions()

    window.addEventListener('resize', () => {
      this.applyDimensions()
    })
    window.addEventListener('mousedown', () => {
      this.startVideo()
    })
  },
  computed: {
    videoDimensions: {
      get: function () {
        return `width: ${this.width}px; height: ${this.height}px`
      },
      set: function (payload) {
        this.width = payload.width
        this.height = payload.height
      }
    }
  },
  methods: {
    startVideo () {
      if (!this.started) {
        try {
          this.$refs.video.play()
          this.started = true
          window.removeEventListener('mousedown')
        } catch (e) {}
      }
    },
    applyDimensions () {
      const height = window.innerHeight
      const width = window.innerWidth
      const videoRatio = (800 / 2000)
      const wrapperRatio = (height / width)
      let videoWidth, videoHeight
      if (wrapperRatio > videoRatio) {
        videoHeight = height
        videoWidth = height / videoRatio
      } else {
        videoWidth = width
        videoHeight = width / videoRatio
      }

      this.videoDimensions = {
        width: videoWidth,
        height: videoHeight
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.video-wrapper {
  position: fixed;
  z-index: -1;
}

.is-samsung .video-bg {
  height: 100%;
}
.video-bg {
  position: absolute;
  height: 100%;

  @media screen and (max-height: 820px) {
    position: absolute;
    height: auto;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Video.vue